import ReactDom from 'react-dom';

const PopupDom = ({ domName, children }) => {
    const el = document.getElementById(domName);
    return ReactDom.createPortal(children, el);
};

export default PopupDom;